import { ChangeDetectionStrategy, Component, input } from '@angular/core'

@Component({
  selector: 'banner-tip',
  imports: [],
  standalone: true,
  templateUrl: './banner-tip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BannerTipComponent {
  text = input<string>('')
  image = input<string>('')
}
